import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {
  Paper,
  Dialog,
  MenuItem,
  Snackbar,
  TextField,
  DatePicker,
  TimePicker,
  FlatButton,
  SelectField,
  RaisedButton,
  CircularProgress
} from 'material-ui'
import {
  Table,
  TableRow,
  TableBody,
  TableFooter,
  TableHeader,
  TableRowColumn,
  TableHeaderColumn
} from 'material-ui/Table'
import moment from 'moment'
import UploadDocuments from './UploadDocuments'
import { DealDetails } from '../../components/Common/DealDetails'
import { BrokerDetails } from '../../components/Common/BrokerDetails'
import { HistoryDetails } from './HistoryDetails'
import { instance } from '../../lib/api'
import Header from '../../components/Header/Header'
import Constants from '../../utils/CommonConstants'
import Documents from '../../components/Documents/Documents'
import FileDetails from '../../components/Common/FileDetails'
import {
  LOAD_COUNT_DECREMENT,
  LOAD_COUNT_INCREMENT,
  SHOW_SNACKBAR_TOASTR
} from '../../actions/loading'

const toUpperCase = str => {
  return str ? str.toUpperCase() : str
}

const DATE_FORMAT = 'YYYY-MM-DD'
const styleCss = {
  bottomFixedStyle: {},
  paperWrapper: {
    marginTop: 5,
    marginBottom: 5,
    padding: 5
  }
}
const btnStyle = {
  margin: 12
}

class PaymentDetails extends Component {
  render() {
    const { rcmOrder, paymentDetail, isReadOnly, paymentIndex } = this.props
    const { paymentModes, paymentStatuses } = Constants
    let paymentMode = {
      isCheque: false,
      isOnline: false,
      isCash: false
    }
    if (paymentDetail.payment_mode_id) {
      const localVariable = paymentModes[paymentDetail.payment_mode_id]
      paymentMode = {
        isCheque: localVariable === 'CHEQUE',
        isOnline: localVariable === 'ONLINE',
        isCash: localVariable === 'CASH'
      }
    }

    let activeStatusMenuMap
    if (Constants.newFollowupStatusIds.indexOf(rcmOrder.statusId) !== -1) {
      activeStatusMenuMap = ['DEPOSITED', 'COLLECTED']
    } else if (rcmOrder.statusId == Constants.pendingFinanceApprovalStatusId) {
      activeStatusMenuMap = ['CLEARED', 'BOUNCED']
    } else {
      activeStatusMenuMap = ['DEPOSITED', 'COLLECTED', 'CLEARED', 'BOUNCED']
    }

    return (
      <div className='row payment-detail-row'>
        <div className='col-xs-6 col-md-4 col-lg-3'>
          <TextField
            hintText='Payment Mode'
            floatingLabelText='Payment Mode'
            disabled
            value={paymentModes[paymentDetail.payment_mode_id] || ''}
          />
        </div>
        {paymentMode.isCheque && (
          <React.Fragment>
            <div className='col-xs-6 col-md-4 col-lg-3'>
              <TextField
                hintText='Cheque Amount'
                floatingLabelText='Cheque Amount'
                disabled={isReadOnly}
                type='number'
                value={paymentDetail.amount || ''}
                onChange={(event, value) =>
                  this.props.onPaymentDetailChange(
                    'amount',
                    value,
                    paymentIndex
                  )
                }
              />
            </div>
            <div className='col-xs-6 col-md-4 col-lg-3'>
              <TextField
                hintText='Enter Cheque Number'
                floatingLabelText='Cheque Number'
                disabled={isReadOnly}
                value={paymentDetail.instrument_number || ''}
                onChange={(event, value) =>
                  this.props.onPaymentDetailChange(
                    'instrument_number',
                    value,
                    paymentIndex
                  )
                }
              />
            </div>
            <div className='col-xs-6 col-md-4 col-lg-3'>
              <TextField
                hintText='Cheque Bank'
                floatingLabelText='Cheque Bank'
                disabled={isReadOnly}
                value={paymentDetail.bank_name || ''}
                onChange={(event, value) =>
                  this.props.onPaymentDetailChange(
                    'bank_name',
                    value,
                    paymentIndex
                  )
                }
              />
            </div>
            <div className='col-xs-6 col-md-4 col-lg-3'>
              <DatePicker
                hintText='Cheque Due Date'
                floatingLabelText='Cheque Due Date'
                disabled={isReadOnly}
                value={
                  paymentDetail.cheque_date
                    ? moment(paymentDetail.cheque_date).toDate()
                    : null
                }
                onChange={(event, value) =>
                  this.props.onPaymentDateFieldChange(
                    'cheque_date',
                    value,
                    paymentIndex
                  )
                }
              />
            </div>
            <div className='col-xs-6 col-md-4 col-lg-3'>
              <DatePicker
                hintText='Expected Deposit Date'
                floatingLabelText='Expected Deposit Date'
                disabled={isReadOnly}
                minDate={
                  paymentDetail.cheque_date
                    ? moment(paymentDetail.cheque_date).toDate()
                    : null
                }
                value={
                  paymentDetail.cheque_expected_deposit_date
                    ? moment(
                        paymentDetail.cheque_expected_deposit_date
                      ).toDate()
                    : null
                }
                onChange={(event, value) =>
                  this.props.onPaymentDateFieldChange(
                    'cheque_expected_deposit_date',
                    value,
                    paymentIndex
                  )
                }
              />
            </div>
          </React.Fragment>
        )}
        {paymentMode.isCash && (
          <React.Fragment>
            <div className='col-xs-6 col-md-4 col-lg-3'>
              <TextField
                hintText='Cash Amount'
                floatingLabelText='Cash Amount'
                disabled={isReadOnly}
                type='number'
                value={paymentDetail.amount || ''}
                onChange={(event, value) =>
                  this.props.onPaymentDetailChange(
                    'amount',
                    value,
                    paymentIndex
                  )
                }
              />
            </div>
            <div className='col-xs-6 col-md-4 col-lg-3'>
              <TextField
                hintText='Deposit Slip No.'
                floatingLabelText='Slip No.'
                disabled={isReadOnly}
                value={paymentDetail.instrument_number || ''}
                onChange={(event, value) =>
                  this.props.onPaymentDetailChange(
                    'instrument_number',
                    value,
                    paymentIndex
                  )
                }
              />
            </div>
          </React.Fragment>
        )}
        {paymentMode.isOnline && (
          <React.Fragment>
            <div className='col-xs-6 col-md-4 col-lg-3'>
              <TextField
                hintText='Online Amount'
                floatingLabelText='Online Amount'
                disabled={isReadOnly}
                type='number'
                value={paymentDetail.amount || ''}
                onChange={(event, value) =>
                  this.props.onPaymentDetailChange(
                    'amount',
                    value,
                    paymentIndex
                  )
                }
              />
            </div>
            <div className='col-xs-6 col-md-4 col-lg-3'>
              <TextField
                hintText='Online Bank'
                floatingLabelText='Online Bank'
                disabled={isReadOnly}
                value={paymentDetail.bank_name || ''}
                onChange={(event, value) =>
                  this.props.onPaymentDetailChange(
                    'bank_name',
                    value,
                    paymentIndex
                  )
                }
              />
            </div>
            <div className='col-xs-6 col-md-4 col-lg-3'>
              <TextField
                hintText='Online UTR'
                floatingLabelText='Online UTR'
                disabled={isReadOnly}
                value={paymentDetail.instrument_number || ''}
                onChange={(event, value) =>
                  this.props.onPaymentDetailChange(
                    'instrument_number',
                    value,
                    paymentIndex
                  )
                }
              />
            </div>
          </React.Fragment>
        )}
        <div className='col-xs-6 col-md-4 col-lg-3'>
          <DatePicker
            hintText='Clearance Date'
            floatingLabelText='Clearance Date'
            disabled={isReadOnly}
            value={
              paymentDetail.payment_clearance_date
                ? moment(paymentDetail.payment_clearance_date).toDate()
                : null
            }
            onChange={(event, value) =>
              this.props.onPaymentDateFieldChange(
                'payment_clearance_date',
                value,
                paymentIndex
              )
            }
          />
        </div>
        <div className='col-xs-6 col-md-4 col-lg-3'>
          <DatePicker
            hintText='Deposit Date'
            floatingLabelText='Deposit Date'
            disabled={isReadOnly}
            value={
              paymentDetail.deposit_date
                ? moment(paymentDetail.deposit_date).toDate()
                : null
            }
            onChange={(event, value) =>
              this.props.onPaymentDateFieldChange(
                'deposit_date',
                value,
                paymentIndex
              )
            }
          />
        </div>
        <div className='col-xs-6 col-md-4 col-lg-3'>
          <TextField
            hintText='Handedover To'
            floatingLabelText='Handedover To'
            disabled={isReadOnly}
            value={paymentDetail.handover_to || ''}
            fullWidth
            onChange={(event, value) =>
              this.props.onPaymentDetailChange(
                'handover_to',
                value,
                paymentIndex
              )
            }
          />
        </div>
        <div className='col-xs-6 col-md-4 col-lg-3'>
          <DatePicker
            hintText='Handedover Date'
            floatingLabelText='Handedover Date'
            disabled={isReadOnly}
            value={
              paymentDetail.handover_date
                ? moment(paymentDetail.handover_date).toDate()
                : null
            }
            onChange={(event, value) =>
              this.props.onPaymentDateFieldChange(
                'handover_date',
                value,
                paymentIndex
              )
            }
          />
        </div>
        <div className='col-xs-6 col-md-4 col-lg-3'>
          <SelectField
            floatingLabelText='Status'
            disabled={isReadOnly}
            value={paymentDetail.payment_status_id}
            onChange={(event, idx, value) =>
              this.props.onPaymentDetailChange(
                'payment_status_id',
                value,
                paymentIndex
              )
            }
          >
            {Object.keys(paymentStatuses)
              .map(Number)
              .map(key => (
                <MenuItem
                  key={key}
                  value={key}
                  primaryText={paymentStatuses[key]}
                  disabled={
                    activeStatusMenuMap.indexOf(paymentStatuses[key]) === -1
                  }
                />
              ))}
          </SelectField>
        </div>
        <div className='col-xs-6 col-md-4 col-lg-3'>
          <DatePicker
            hintText='Tax Invoice Date'
            floatingLabelText='Tax Invoice Date'
            disabled={isReadOnly}
            value={
              paymentDetail.tax_invoice_date
                ? moment(paymentDetail.tax_invoice_date).toDate()
                : null
            }
            onChange={(event, value) =>
              this.props.onPaymentDateFieldChange(
                'tax_invoice_date',
                value,
                paymentIndex
              )
            }
          />
        </div>
        <div className='col-xs-6 col-md-4 col-lg-3'>
          <TextField
            hintText='Tax Invoice Number'
            floatingLabelText='Tax Invoice Number'
            disabled={isReadOnly}
            value={paymentDetail.tax_invoice_number || ''}
            fullWidth
            onChange={(event, value) =>
              this.props.onPaymentDetailChange(
                'tax_invoice_number',
                value,
                paymentIndex
              )
            }
          />
        </div>
        <div className='col-xs-6 col-md-4 col-lg-3'>
          <TextField
            hintText='Tax Invoice Sent'
            floatingLabelText='Tax Invoice Sent'
            disabled={isReadOnly}
            value={paymentDetail.tax_invoice_sent || ''}
            fullWidth
            onChange={(event, value) =>
              this.props.onPaymentDetailChange(
                'tax_invoice_sent',
                value,
                paymentIndex
              )
            }
          />
        </div>
        <div className='col-xs-12'>
          <TextField
            hintText='Comments'
            floatingLabelText='Comments'
            disabled
            value={paymentDetail.comments || ''}
            fullWidth
          />
        </div>
      </div>
    )
  }
}

export default class BrokerOrderDetails extends Component {
  constructor(props) {
    super(props)
    this.state = {
      _reason: null,
      openSnackbar: false,
      snackbarMessage: '',
      isloading: true,
      orderDetails: props.order,
      reasonList: [],
      isStatusOnline: false,
      isReadOnly: true,
      isUploadDocuments: false,
      noCaseToPull: false,
      notes: '',
      followupRequired: null
    }
    const rcmOrder = props.order.rcmOrder
    if (rcmOrder.fupTime) {
      this.state.followUpDate = moment(rcmOrder.fupTime).toDate()
      this.state.followUpTime = moment(rcmOrder.fupTime).toDate()
    }
    this.handleFollowupDate = this.handleFollowupDate.bind(this)
    this.handleFollowupTime = this.handleFollowupTime.bind(this)
    this.handleModalClose = this.handleModalClose.bind(this)
    this.submit = this.submit.bind(this)
    this.uploadDocumentsSuccess = this.uploadDocumentsSuccess.bind(this)
    this.handleRequestSnackbarClose = this.handleRequestSnackbarClose.bind(this)
    this.handleCommentsChange = this.handleCommentsChange.bind(this)
    this.handleCommentNotesChange = this.handleCommentNotesChange.bind(this)
    this.toggelUploadDocuments = this.toggelUploadDocuments.bind(this)
    this.handlePaymentDetailsChange = this.handlePaymentDetailsChange.bind(this)
    this.handlePaymentDateFieldChange =
      this.handlePaymentDateFieldChange.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.order !== this.props.order) {
      const newState = {
        orderDetails: nextProps.order
      }
      const rcmOrder = nextProps.order.rcmOrder
      if (rcmOrder.fupTime) {
        newState.followUpDate = moment(rcmOrder.fupTime).toDate()
        newState.followUpTime = moment(rcmOrder.fupTime).toDate()
      } else {
        newState.followUpDate = null
        newState.followUpTime = null
      }
      newState.isReadOnly =
        nextProps.reasonList.length === 0 || nextProps.isSalesRoleOnly
      this.setState(newState)
    }
    if (nextProps.reasonList !== this.props.reasonList) {
      this.setState({
        reasonList: nextProps.reasonList,
        isReadOnly:
          nextProps.reasonList.length === 0 || nextProps.isSalesRoleOnly
      })
    }
  }
  uploadDocumentsSuccess() {
    this.props.refreshBrokerOrderDocuments(this.state.orderDetails.rcmOrder.id)
  }
  toggelUploadDocuments() {
    this.setState({
      isUploadDocuments: !this.state.isUploadDocuments
    })
  }
  handleCommentNotesChange(key, value) {
    this.setState({
      notes: value
    })
  }

  handlePaymentDetailsChange(key, value, paymentDetailIndex) {
    let { orderDetails } = this.state
    orderDetails.platform_order_details.payments_details[paymentDetailIndex][
      key
    ] = value
    this.setState({
      orderDetails
    })
  }
  handlePaymentDateFieldChange(key, value, paymentDetailIndex) {
    let { orderDetails } = this.state
    orderDetails.platform_order_details.payments_details[paymentDetailIndex][
      key
    ] = moment(value).format(DATE_FORMAT)
    this.setState({
      orderDetails
    })
  }
  handleFollowupDate(event, date) {
    this.setState({
      followUpDate: date
    })
  }
  handleFollowupTime(event, date) {
    this.setState({
      followUpTime: date
    })
  }
  handleModalClose() {
    this.setState({
      showModal: '',
      isUploadDocuments: false
    })
  }
  showModal(modal) {
    this.setState({
      showModal: modal
    })
  }
  handleRequestSnackbarClose() {
    this.setState({
      openSnackbar: false
    })
  }
  handleCommentsChange(event, index, value) {
    this.setState({
      _reason: value,
      followupRequired:
        Constants.followupStatus.indexOf(value.nextStatusId) !== -1
          ? Constants.configMsgs.required
          : null
    })
  }
  handlePaymentAmountChange(key, value) {
    let { orderDetails } = this.state
    orderDetails.platform_order_details[key] = value
    this.setState({
      orderDetails
    })
  }

  submit() {
    if (!this.state.orderDetails.rcmOrder.agentId) {
      this.setState({
        openSnackbar: true,
        snackbarMessage: 'This Order is Unassigned.'
      })
      return
    }
    const reasonID = this.state._reason ? this.state._reason.id : null
    const platformData = this.state.orderDetails.platform_order_details
    const rcmOrder = this.state.orderDetails.rcmOrder
    const putData = {
      rcmOrder,
      platform_order_details: {
        deal_details: platformData.deal_details,
        payments_details: platformData.payments_details,
        amount: platformData.amount,
        tds_deducted: platformData.tds_deducted,
        billing_address: platformData.billing_address
      }
    }
    if (!reasonID) {
      this.setState({
        openSnackbar: true,
        snackbarMessage: 'Please select a reason.'
      })
      return
    }
    const followuptime = moment(this.state.followUpDate)
    if (this.state.followUpDate && this.state.followUpTime) {
      const time = moment(this.state.followUpTime)
      followuptime.set({ hour: time.get('hour'), minute: time.get('minute') })
    } else if (
      Constants.followupStatus.indexOf(this.state._reason.nextStatusId) !== -1
    ) {
      this.setState({
        openSnackbar: true,
        snackbarMessage: 'Please select followup Date and Time.'
      })
      return
    }
    putData.rcmOrder.fupTime = this.state.followUpDate
      ? followuptime.valueOf()
      : null
    putData.reasonId = reasonID ? reasonID : null
    putData.notes = this.state.notes
    const url = Constants.configUrls.BROKER_PUT(rcmOrder.id)
    this.props.putHandler(putData, url)
  }

  render() {
    const { orderDetails, notes, isUploadDocuments, reasonList, isReadOnly } =
      this.state
    const { brokerDocuments } = this.props
    const rcmOrder = orderDetails.rcmOrder,
      platformDetails = orderDetails.platform_order_details,
      paymentDetails = platformDetails.payments_details

    return (
      <div>
        <div>
          <section className='order-rcm-info clearfix'>
            <div className='col-xs-6 col-md-3'>
              <p className='lg-info'>
                <strong>Order ID: </strong>
                {rcmOrder ? rcmOrder.orderId : '----------'}
              </p>
              <p className='sm-info'>
                ({this.props.caseStatusMap[rcmOrder.statusId]})
              </p>
            </div>
            <div className='col-xs-6'>
              <p className='lg-info'>
                {platformDetails.deal_details.seller_details &&
                platformDetails.deal_details.seller_details.name
                  ? platformDetails.deal_details.seller_details.name
                  : '----------'}
              </p>
            </div>
            <div className='col-xs-6 col-md-3'>
              <p className='lg-info'>
                {platformDetails.deal_details.seller_details &&
                platformDetails.deal_details.seller_details.contact
                  ? platformDetails.deal_details.seller_details.contact
                  : '----------'}
              </p>
              <p className='sm-info'>
                {orderDetails.cityName ? orderDetails.cityName : '----------'}
              </p>
            </div>
          </section>
          <div className='container-fluid' style={{ paddingBottom: '60px' }}>
            <Paper zDepth={1} style={styleCss.paperWrapper}>
              <div className='container-fluid'>
                <div className='row box-wrap'>
                  <p>
                    Deal Details{' '}
                    <span className='static-field pull-right'>
                      <label>Term Sheet Number: </label>{' '}
                      {platformDetails.deal_details.term_sheet_number}
                    </span>
                  </p>
                  <DealDetails
                    details={platformDetails.deal_details.product_info}
                  />
                </div>
                <div className='row box-wrap'>
                  <p>Payment Details</p>
                  <div className='col-xs-12'>
                    <div className='row'>
                      <div className='col-xs-6 col-md-4 col-lg-3'>
                        <TextField
                          hintText='Amount'
                          floatingLabelText='Amount'
                          disabled={isReadOnly}
                          type='number'
                          value={platformDetails.amount || ''}
                          onChange={(event, value) =>
                            this.handlePaymentAmountChange('amount', value)
                          }
                        />
                      </div>
                      <div className='col-xs-6 col-md-4 col-lg-3'>
                        <TextField
                          hintText='GST'
                          floatingLabelText='GST'
                          type='number'
                          disabled
                          value={platformDetails.gst_amount || ''}
                        />
                      </div>
                      <div className='col-xs-6 col-md-4 col-lg-3'>
                        <TextField
                          hintText='TDS'
                          floatingLabelText='TDS Deducted'
                          disabled={isReadOnly}
                          type='number'
                          value={platformDetails.tds_deducted || ''}
                          onChange={(event, value) =>
                            this.handlePaymentAmountChange(
                              'tds_deducted',
                              value
                            )
                          }
                        />
                      </div>
                      <div className='col-xs-6 col-md-4 col-lg-3'>
                        <TextField
                          hintText='Discount'
                          floatingLabelText='Discount'
                          disabled
                          type='number'
                          value={platformDetails.discount || ''}
                        />
                      </div>
                      <div className='col-xs-6 col-md-4 col-lg-3'>
                        <TextField
                          hintText='Sales Approval Authority'
                          floatingLabelText='Sales Approval Authority'
                          disabled
                          value={platformDetails.sales_approver_authority || ''}
                        />
                      </div>
                      <div className='col-xs-12'>
                        <TextField
                          hintText='Billing Address'
                          floatingLabelText='Billing Address'
                          disabled={isReadOnly}
                          fullWidth
                          value={platformDetails.billing_address || ''}
                          onChange={(event, value) =>
                            this.handlePaymentAmountChange(
                              'billing_address',
                              value
                            )
                          }
                        />
                      </div>
                    </div>
                    {paymentDetails.map((paymentDetail, index) => (
                      <PaymentDetails
                        key={paymentDetail.id}
                        rcmOrder={rcmOrder}
                        paymentDetail={paymentDetail}
                        paymentIndex={index}
                        isReadOnly={isReadOnly}
                        onPaymentDetailChange={this.handlePaymentDetailsChange}
                        onPaymentDateFieldChange={
                          this.handlePaymentDateFieldChange
                        }
                      />
                    ))}
                  </div>
                </div>
                <div className='row box-wrap box-grey'>
                  <div className='col-xs-12'>
                    <div className='col-md-3 col-xs-4'>
                      <label className='line-height-50'>Comment</label>
                    </div>
                    <div className='col-md-9 col-xs-8'>
                      <SelectField
                        value={this.state._reason}
                        onChange={this.handleCommentsChange}
                        hintText={'Select Comment'}
                        disabled={isReadOnly}
                        fullWidth
                      >
                        {reasonList.map(reason => {
                          return (
                            <MenuItem
                              value={reason}
                              key={reason.id}
                              primaryText={reason.label}
                            />
                          )
                        })}
                      </SelectField>
                    </div>
                  </div>
                  <div className='col-xs-12'>
                    <div className='col-md-3 col-xs-4'>
                      <label className='line-height-50'>Followup Date</label>
                    </div>
                    <div className='row col-md-9 col-xs-8'>
                      <div className='col-xs-6 col-md-4'>
                        <DatePicker
                          hintText='Followup Date'
                          value={this.state.followUpDate}
                          onChange={this.handleFollowupDate}
                          minDate={moment().toDate()}
                          errorText={
                            this.state.followUpDate
                              ? null
                              : this.state.followupRequired
                          }
                          disabled={isReadOnly}
                        />
                      </div>
                      <div className='col-xs-6 col-md-4'>
                        <TimePicker
                          format='ampm'
                          minutesStep={5}
                          hintText='Followup Time'
                          errorText={
                            this.state.followUpTime
                              ? null
                              : this.state.followupRequired
                          }
                          onChange={this.handleFollowupTime}
                          value={this.state.followUpTime}
                          disabled={isReadOnly}
                        />
                      </div>
                    </div>
                  </div>
                  <div className='col-xs-12'>
                    <div className='col-md-3 col-xs-4'>
                      <label className='line-height-50'>Notes</label>
                    </div>
                    <div className='col-md-9 col-xs-8'>
                      <TextField
                        hintText='Notes'
                        disabled={isReadOnly}
                        value={notes}
                        onChange={this.handleCommentNotesChange}
                        fullWidth
                      />
                    </div>
                  </div>
                  <div className='col-xs-12 text-center'>
                    <RaisedButton
                      label='Submit'
                      primary
                      disabled={isReadOnly}
                      style={btnStyle}
                      onClick={this.submit}
                    />
                  </div>
                </div>
                <section className='footer-fixed-actions'>
                  <div
                    className='footer-action-item'
                    onClick={() => this.showModal('broker')}
                  >
                    Broker Details
                  </div>
                  <div
                    className='footer-action-item'
                    onClick={() => this.showModal('documents')}
                  >
                    Documents
                  </div>
                  <div
                    className='footer-action-item'
                    onClick={() => this.showModal('history')}
                  >
                    History
                  </div>
                </section>
              </div>
            </Paper>
          </div>
        </div>
        }
        <Snackbar
          open={this.state.openSnackbar}
          message={this.state.snackbarMessage}
          autoHideDuration={4000}
          onRequestClose={this.handleRequestSnackbarClose}
          onActionClick={this.handleRequestSnackbarClose}
          action={'GOT IT'}
        />
        <Dialog
          title='Broker Details'
          actions={
            <FlatButton label='Close' primary onClick={this.handleModalClose} />
          }
          modal={false}
          open={this.state.showModal === 'broker'}
          onRequestClose={this.handleModalClose}
        >
          {platformDetails.deal_details &&
          platformDetails.deal_details.buyer_details ? (
            <BrokerDetails
              details={platformDetails.deal_details.buyer_details}
            />
          ) : (
            <p>Broker Details not available.</p>
          )}
        </Dialog>
        <Dialog
          title='Documents'
          actions={[
            <FlatButton
              label={isUploadDocuments ? 'Done Upload' : 'Upload Documents'}
              primary
              disabled={isReadOnly}
              onClick={this.toggelUploadDocuments}
            />,
            <FlatButton label='Close' primary onClick={this.handleModalClose} />
          ]}
          modal={false}
          open={this.state.showModal === 'documents'}
          onRequestClose={this.handleModalClose}
          autoScrollBodyContent
        >
          {isUploadDocuments ? (
            <UploadDocuments
              orderId={rcmOrder.orderId}
              orderType={rcmOrder.caseSubTypeId}
              onUploadSuccess={this.uploadDocumentsSuccess}
              dispatch={this.props.dispatch}
              docTypes={Constants.documentTypes.BROKER_ORDER}
            />
          ) : brokerDocuments && Object.keys(brokerDocuments).length ? (
            <Documents
              documents={brokerDocuments}
              onDeleteSuccess={this.uploadDocumentsSuccess}
              dispatch={this.props.dispatch}
            />
          ) : (
            <p>No documents to show.</p>
          )}
        </Dialog>
        <Dialog
          title='History Details'
          autoScrollBodyContent
          actions={
            <FlatButton label='Close' primary onClick={this.handleModalClose} />
          }
          modal={false}
          open={this.state.showModal === 'history'}
          onRequestClose={this.handleModalClose}
        >
          {rcmOrder.actions && rcmOrder.actions.length ? (
            <HistoryDetails
              caseActions={rcmOrder.actions}
              caseStatusMap={this.props.caseStatusMap}
            />
          ) : (
            <p>History Details not available.</p>
          )}
        </Dialog>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/containers/OrderDetails/BrokerOrderDetails.js
 **/